import { QuickLink } from '@shared/banners/QuickLink';
import { QuickLinkDto } from './QuickLinkDto';
import { extractActionType } from '../cmsShared/clickHandlerMapper';
import { featureFlagService } from '@superbet-group/web.lib.flags';

export async function mapQuickLink(dto: QuickLinkDto): Promise<QuickLink> {
    const isQuickLinkFlagVisible = await featureFlagService.getFeatureValue(dto.name, true);

    return {
        ...dto,
        visible: dto.visible && isQuickLinkFlagVisible,
        actionType: extractActionType(dto.link, dto.howToOpen),
    };
}
